module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEFSURBVEiJtdbBbcJAEIXhfyKXQKANDuROOogUHLsMo1zSAMoRukjA5pAK4M6FOoB0QDxcAhJWrHjGy7vtzq4+jTRaLRiTFjpICx1Y791ZDie5ZqpsVNkkhb7fDBJ4vSyUtyTX6U2gEr4qW1lTzATtOmSqLD2YWCCA4Uqj7p5PEZ4rpdk8lnEwyIu5IA/mhqxYK8iCtYaaYqbxrsv6UY67e9I/R//3BQnS0Tl1nYnwEKSjqwha3fopOQaDhiuNugc+BEaV0jh/kW24YahB5rHMINR4/4O0hpoirSAL4oasiAvyIGbIiwBEFqj3zRQHAtbPifLkQcxQWTLxIK7EC+3HC+1b750AgC2U4JG3Cq4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/m3.png
// module id = t6JA
// module chunks = 1